import { TheOldStationNurseryTheme as TheOldStationNurseryMFTheme } from '@famly/mf_theme';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const TheOldStationNurseryPrimaryColor = '#df6e3a';
const TheOldStationNurseryPrimary = TheOldStationNurseryPrimaryColor;
const TheOldStationNurseryActive = hexToRGBA(TheOldStationNurseryPrimaryColor, 0.8);
const TheOldStationNurseryBackgroundHover = hexToRGBA(TheOldStationNurseryPrimaryColor, 0.04);
const TheOldStationNurseryTheme = {
    ...BaseTheme,
    title: 'The Old Station Nursery',
    chromeColor: TheOldStationNurseryMFTheme.colorPalette.brandColor,
    primary: TheOldStationNurseryPrimary,
    active: TheOldStationNurseryActive,
    backgroundHover: TheOldStationNurseryBackgroundHover,
    mf: TheOldStationNurseryMFTheme,
};
export default TheOldStationNurseryTheme;
